var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.name)?_c('span',{staticClass:"form-selected"},[_c('TextSimple',{attrs:{"size":"xs"}},[_vm._v(_vm._s(_vm.name))]),_c('SvgIcon',{attrs:{"name":"cross"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }